import {Component, Input} from '@angular/core';
import {
  FilterService,
  BaseFilterCellComponent,
} from '@progress/kendo-angular-grid';

@Component({
    selector: 'app-organization-filter',
    template: `
    <kendo-combobox
      [data]='data'
      placeholder="Select Organization..."
      (valueChange)='onChange($event)'
      [value]="localStorageValue !== undefined ? localStorageValue : selectedValue"
      [valuePrimitive]='true'
      [textField]='textField'
      [valueField]='valueField'
    >
    </kendo-combobox>
  `,
    standalone: false
})
export class OrganizationFilterComponent extends BaseFilterCellComponent {
  // [value]='localStorageValue !== undefined ? localStorageValue : selectedValue'
  public get selectedValue(): any {
    const filter = this.filterByField(this.valueField);
    return filter ? filter.value : null;
  }

  @Input() public override filter: any;
  @Input() public data: any[];
  @Input() public textField: string;
  @Input() public valueField: string;
  public localStorageValue;

  public get defaultItem(): any {
    return {
      [this.textField]: 'Select Organization...',
      [this.valueField]: null,
    };
  }

  constructor(filterService: FilterService) {
    super(filterService);
    if (localStorage.getItem('orgTypeFilter') !== null && localStorage.getItem('orgTypeFilter') !== 'undefined') {
      this.localStorageValue = Number(localStorage.getItem('orgTypeFilter'));
    } else {
      this.localStorageValue = undefined;
    }
  }

  public onChange(value: any): void {
    if (value !== null) {
      localStorage.setItem('orgTypeFilter', value);
    } else {
      localStorage.removeItem('orgTypeFilter');
    }
    this.applyFilter(
      value === null || value === undefined // value of the default item
        ? this.removeFilter('org') // remove the filter
        :
        this.updateFilter({
          // add a filter for the field with the value
          field: 'org',
          operator: 'eq',
          value,
        })
    ); // update the root filter
  }
}
